module.exports = __webpack_public_path__ + "static/media/__closed.d656be15.svg";